import { useMemo } from 'react';
import { DataTableDataSearchDto } from '@asset-metrix/portal-gateway-client-js';

import { CUSTOM_FILTER_INSTANCE_ID_SUFFIX } from '../../utils/constants';

import { useEffectiveGlobalSelections } from './useEffectiveGlobalSelections';
import { useSelections } from './useSelections';

export type PageFilterSelections = NonNullable<
  DataTableDataSearchDto['selection']
>;

export function getCustomPageFilterInstanceId(
  pageFilterInstanceId: string
): string {
  return `${pageFilterInstanceId}${CUSTOM_FILTER_INSTANCE_ID_SUFFIX}`;
}

export function useCombinedPageFilterSelections(
  pageFilterInstanceId: string
): PageFilterSelections {
  const customPageFilterInstanceId =
    getCustomPageFilterInstanceId(pageFilterInstanceId);

  const globalFilterSelections = useEffectiveGlobalSelections();
  const pageFilterSelections = useSelections(pageFilterInstanceId);
  const customPageFilterSelections = useSelections(customPageFilterInstanceId);

  return useMemo(
    () => ({
      ...globalFilterSelections,
      ...pageFilterSelections,
      ...customPageFilterSelections,
    }),
    [globalFilterSelections, pageFilterSelections, customPageFilterSelections]
  );
}
